export default "__VITE_ASSET__398186b5__"